import { fetchPost, fetchGet , fetchPut , fetchDelete} from '@/utils/request'

//百科模块接口

export function categoriesList (query) { //分类列表
    return fetchGet('/gateway/v1/wikipedia-categories', query)
}
export function categoriesLevelOne() { //一级分类列表
    return fetchGet('/gateway/v1/wikipedia-categories/sub-list')
}
export function categoriesLevelTwo (id) { //查询分类
    return fetchGet('/gateway/v1/wikipedia-categories/'+id+'/detail')
}
export function addCategorie (params) { //新增分类
    return fetchPost('/gateway/v1/wikipedia-categories', params)
}
export function editCategorie (id,params) { //新增分类
    return fetchPut('/gateway/v1/wikipedia-categories/'+id, params)
}
export function deleteCategorie (id) { //删除分类
    return fetchDelete('/gateway/v1/wikipedia-categories/'+id)
}
export function editWikipediaCatSort (id,params) { //修改百科分类排序
    return fetchPut('/gateway/v1/wikipedia-categories/'+id+'/sort',params)
}

export function getWikipediaList (params) { //百科列表模块
    return fetchGet('/gateway/v1/manager/wikipedia-list', params)
}
export function addWikipedia (params) { //新增百科
    return fetchPost('/gateway/v1/manager/wikipedia', params)
}

export function getWikipediaDetail (id) { //百科详情
    return fetchGet('/gateway/v1/manager/wikipedia/'+id)
}

export function editWikipediaDetail (id,params) { //编辑百科
    return fetchPut('/gateway/v1/manager/wikipedia/'+id,params)
}

export function deleteWikipedia (param) { //删除百科
    return fetchDelete('/gateway/v1/manager/wikipedia-list',param)
}

export function editWikipediaSort (id,params) { //修改百科排序
    return fetchPut('/gateway/v1/wikipedia/'+id+'/sort',params)
}

export function getWikipediaLabels (params) { //百科标签
    return fetchGet('/gateway/v1/wikipedia-tags',params)
}
export function MHgetWikipediaLabel (params) { //模糊查询标签
    return fetchGet('/gateway/v1/wikipedia-tags/name',params)
}
export function addWikipediaLabel (params) { //新增百科标签
    return fetchPost('/gateway/v1/wikipedia-tag',params)
}
export function editWikipediaLabel (id,params) { //编辑百科标签
    return fetchPut('/gateway/v1/wikipedia-tag/'+id,params)
}
export function deleteWikipediaLabel (id) { //删除标签
    return fetchDelete('/gateway/v1/wikipedia-tag/'+id)
}
/* 文件上传 */
export function uploadFile (tosId,params) {
    return fetchPost('/gateway/v1/tos/'+tosId+'/files', params, {
        'Content-Type': 'multipart/form-data'
    })
}
export function listCategoriesLevelOne() { //百科列表一级分类列表
    return fetchGet('/gateway/v1/wikipedia-list/categories-sub-list')
}
export function lisCategoriesLevelTwo (id) { //百科列表查询分类
    return fetchGet('/gateway/v1/wikipedia-list/'+id+'/categories-detail')
}
export function listAddWikipediaLabel (params) { //百科列表新增百科标签
    return fetchPost('/gateway/v1/wikipedia-list/wikipedia-tag',params)
}
export function listMHgetWikipediaLabel (params) { //百科列表模糊查询标签
    return fetchGet('/gateway/v1/wikipedia-list/tag-name',params)
}
//视频上传获取临时上传key
export function getVideoKey (code,params) {
    return fetchPost('/gateway/v1/tos/'+code+'/tmp-key', params)
}
//视频入库
export function getVideoSave (params) {
    return fetchPost('/gateway/v1/video', params)
}